// src/components/prompts/DealFlowPrompt.jsx
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import routes from '../routes';

const DealFlowPrompt = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCreateNewDeal = () => {
    onClose();
    navigate('/deal-flow', {
      state: {
        fromDealFlowPrompt: true,
      },
    });
  };

  const handleDismiss = () => {
    onClose();
  };


  const isPublicPage = routes.publicRoutes.some(
    (route) => `/${route.path}` === location.pathname,
  );

  const isAdminPage = routes.adminRoutes.some(
    (route) => `/${route.path}` === location.pathname,
  );

  const isDealPage = location.pathname === '/deal-flow';

  const showModal = isOpen && !isDealPage && !isPublicPage && !isAdminPage;

  return (
    <Modal
      zIndex={1500}
      isOpen={showModal}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent
        mt={[2, 4]}
        mx={[2, 4]}
        maxW={['90%', '85%', '80%', '600px']}
        borderRadius="lg"
      >
        <ModalHeader fontSize={['lg', 'xl']}>Create a new Deal</ModalHeader>
        <ModalBody>
          <VStack spacing={[3, 4]} align="stretch">
            <Text fontSize={['sm', 'md']}>
              Looking to fund raise? Create a new deal so investors can partake and send in term sheets!
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={handleDismiss}
            size={['sm', 'md']}
          >
            Dismiss
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleCreateNewDeal}
            size={['sm', 'md']}
          >
            Create Deal
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DealFlowPrompt;
